module.exports = __webpack_public_path__ + "img/me.fb6ed8f2.svg";